/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, June 30th 2022, 10:07:43 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useNavigate } from "react-router-dom";
import { resolveURLName } from "core/routes/utils";
import { OrganizationListItem } from "lib/schemas";
import { OrganizationStatusChange } from "organizations/components/OrganizationStatusChange";
import { DataTable, HeadCell, OSAvatar, OSIconButton } from "ui-widgets";

const headCells: HeadCell<OrganizationListItem>[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email Address",
  },
  {
    id: "phone",
    numeric: false,
    disablePadding: false,
    label: "Phone",
  },
  {
    id: "default_currency",
    numeric: false,
    disablePadding: true,
    label: "Currency",
  },
  {
    id: "organization_status",
    numeric: false,
    disablePadding: false,
    label: "Active Status",
    ActionComponent: OrganizationStatusChange,
  },
];

export const OrganizationTableList = ({ organizations }: { organizations: OrganizationListItem[] }) => {
  const navigate = useNavigate();
  return (
    <DataTable<OrganizationListItem>
      title="Organizations"
      headCells={headCells}
      dataSource={organizations}
      uniqueKey="id"
      defaultOrderBy="name"
      initialRowsPerPage={10}
      unit="Organization"
      titleKey="name"
      searchKeys={["name", "default_currency"]}
      renderItemAvatar={(organization) => <OSAvatar name={organization.name} imageSrc={organization.logo} />}
      renderRowActions={(organization) => (
        <OSIconButton
          onClick={() => navigate(resolveURLName("editOrganization", { organizationId: organization.id }))}
        />
      )}
    />
  );
};
